import React from 'react';
import { useTranslation } from 'react-i18next';

import PolicyNavigation from './PolicyNavigation';

interface DPDPComplianceContentProps {
  onNavigate?: (view: string) => void;
}

const DPDPComplianceContent: React.FC<DPDPComplianceContentProps> = ({ onNavigate }) => {
  const { t } = useTranslation();

  return (
    <div className="max-w-4xl mx-auto vscode-text-primary pt-8">
      <h1 className="text-3xl font-bold mb-6 vscode-text-primary">{t('legal.dpdpTitle')}</h1>

      <div className="prose max-w-none">
        <p className="text-sm vscode-text-secondary mb-6">
          <strong>{t('legal.dpdp.effectiveDate')}:</strong> {t('legal.dpdp.effectiveDateValue')}
          <br />
          <strong>{t('legal.dpdp.lastUpdated')}:</strong> {t('legal.dpdp.lastUpdatedValue')}
        </p>

        <p className="text-lg vscode-text-secondary mb-6">{t('legal.dpdp.intro')}</p>

        {[1, 2, 3, 4, 5, 6, 7, 8, 10, 11].map((section) => {
          const title = t(`legal.dpdp.s${section}Title`, { defaultValue: '' });
          if (!title) return null;

          const intro = t(`legal.dpdp.s${section}Intro`, { defaultValue: '' });
          const listKeys = Array.from({ length: 8 }, (_, i) => `legal.dpdp.s${section}Item${i + 1}`);
          const listItems = listKeys
            .map((key) => t(key, { defaultValue: '' }))
            .filter((item) => item && !item.startsWith('legal.dpdp.'));

          return (
            <section key={section}>
              <h2 className="text-2xl font-semibold mt-8 mb-4">{title}</h2>
              {intro ? <p className="vscode-text-secondary mb-4">{intro}</p> : null}
              {listItems.length > 0 ? (
                <ul className="list-disc list-inside vscode-text-secondary mb-4 space-y-2 ml-4">
                  {listItems.map((item) => (
                    <li key={item}>{item}</li>
                  ))}
                </ul>
              ) : null}
              {[1, 2, 3].map((paraIdx) => {
                const para = t(`legal.dpdp.s${section}Para${paraIdx}`, { defaultValue: '' });
                if (!para || para.startsWith('legal.dpdp.')) return null;
                return (
                  <p key={paraIdx} className="vscode-text-secondary mb-4">
                    {para}
                  </p>
                );
              })}
            </section>
          );
        })}
      </div>

      <PolicyNavigation currentPolicy="dpdp" onNavigate={onNavigate} />
    </div>
  );
};

export default DPDPComplianceContent;
